import { render, staticRenderFns } from "./verification-success.vue?vue&type=template&id=b750e086&"
import script from "./verification-success.vue?vue&type=script&lang=js&"
export * from "./verification-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports